import axios, { type AxiosResponse } from 'axios';
import type { OrderData, OrderPartLinkData, OrderResponse } from '@/venit/services/model/techpubs-cms';

export default class UserOrdersService {
  public list(page: number, pageSize: number): Promise<AxiosResponse<OrderResponse>> {
    return axios.get<OrderResponse>('/api/v1/users/orders', { params: { page, pageSize } });
  }

  public lookupPartLink(partName: string): Promise<AxiosResponse<OrderPartLinkData>> {
    return axios.get<OrderPartLinkData>('/api/v1/users/orders/part-link', { params: { partName } });
  }
}
